import type { ReactNode } from 'react';
import { MessageSquare, Phone, Mail, CalendarPlus } from 'lucide-react';

export type PresenceStatus = 'available' | 'busy' | 'away' | 'offline';

export interface StaffPresenceRowProps {
  initials: string;
  name: string;
  meta?: string;
  presence: PresenceStatus;
  metrics?: string;
  onChat?: () => void;
  onCall?: () => void;
  onEmail?: () => void;
  onBook?: () => void;
  avatarColor?: string;
  rightSlot?: ReactNode;
}

/** Primitive 14: Staff Presence row — Teams SDK-wired. */
export function StaffPresenceRow({
  initials,
  name,
  meta,
  presence,
  metrics,
  onChat,
  onCall,
  onEmail,
  onBook,
  avatarColor = 'var(--pcb-blue)',
  rightSlot,
}: StaffPresenceRowProps): JSX.Element {
  return (
    <div className="staff-row" role="group" aria-label={`${name} — ${presence}`}>
      <span className="staff-row__avatar" style={{ background: avatarColor }}>
        {initials}
        <span className={`staff-row__pres-ring is-${presence}`} aria-hidden />
      </span>
      <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
        <span className="staff-row__name">{name}</span>
        {meta && <span className="staff-row__meta">{meta}</span>}
      </span>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--sp-4)' }}>
        {metrics && (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-600)' }}>
            {metrics}
          </span>
        )}
        {onChat && <button type="button" className="btn btn-link" onClick={onChat} aria-label={`Chat ${name}`}><MessageSquare size={14} /></button>}
        {onCall && <button type="button" className="btn btn-link" onClick={onCall} aria-label={`Call ${name}`}><Phone size={14} /></button>}
        {onEmail && <button type="button" className="btn btn-link" onClick={onEmail} aria-label={`Email ${name}`}><Mail size={14} /></button>}
        {onBook && <button type="button" className="btn btn-link" onClick={onBook} aria-label={`Book with ${name}`}><CalendarPlus size={14} /></button>}
        {rightSlot}
      </span>
    </div>
  );
}
